import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import { PrivateRoute } from 'Auth'
import ShellContainer from 'App/Shell/ShellContainer'

const ShellRoute = ({ component: Component, isGuest = false, ...rest }) => {
  const RouteComponent = isGuest ? Route : PrivateRoute

  return (
    <ShellContainer>
      <Suspense fallback={<div />}>
        <RouteComponent
          {...rest}
          render={matchProps => <Component {...matchProps} />}
        />
      </Suspense>
    </ShellContainer>
  )
}

ShellRoute.propTypes = {
  component: PropTypes.elementType,
  isGuest: PropTypes.bool
}

ShellRoute.defaultProps = {
  isGuest: false
}

export default ShellRoute



// WEBPACK FOOTER //
// ./src/App/Shell/ShellRoute.js